import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {MUTATION_KEYS, QUERY_KEYS, queryClient} from '@/queryClient'
import {AxiosError, AxiosResponse} from 'axios'
import {httpMarkNotification, MarkNotificationPayload} from '../http/notifications.http'
import {FormErrorResponse} from '@/types'
import {errorHandler} from '@/utilities/helpers'

export const useMarkNotification = <TContext = unknown>({
    urlParams,
    options
}: {
    urlParams: {notificationId: string}
    options?: UseMutationOptions<
        AxiosResponse<unknown>,
        AxiosError<{errors: FormErrorResponse[]}>,
        MarkNotificationPayload,
        TContext
    >
}) =>
    useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.MARK_NOTIFICATION],
        mutationFn: payload => {
            return httpMarkNotification(urlParams.notificationId, payload)
        },
        // The hook owns cache reconciliation and the error toast; a caller's own callbacks are
        // composed on top rather than replaced, so an optimistic caller can still roll back.
        onSuccess: (data, variables, context) => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.NOTIFICATIONS]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.NOTIFICATION_COUNT]})
            options?.onSuccess?.(data, variables, context)
        },
        onError: (error, variables, context) => {
            errorHandler(error)
            options?.onError?.(error, variables, context)
        }
    })
